import {Name} from './Name';
import {Price} from './Price';
import {Input} from './Input';
import {Header} from './Header';
import {Rating} from './Rating';
import {Footer} from './Footer';
import {Button} from './Button';
import {Loader} from './Loader';
import {Switch} from './Switch';
import {RatingStars} from './RatingStars';
import {BlockHeading} from './BlockHeading';
import { ErrorBoundary } from './ErrorBoundary';
import {LiveClock} from './LiveClock';
import {LiveDate} from './LiveDate';
import {TextArea} from './TextArea';
import {UploadInput} from './UploadInput';  
import { ImageModal } from './ImageModal';
import {InputCustom} from './InputCustom';


export const components = {
  Name,
  Header,
  Button,
  Input,
  Footer,
  Price,
  Loader,
  Rating,
  Switch,
  RatingStars,
  BlockHeading,
  ErrorBoundary,
  LiveClock,
  LiveDate,
  TextArea,
  UploadInput,
  ImageModal,
  InputCustom,
};
